export function convertToTimeString(timeSeconds = 0) {
  const hours = Math.floor(timeSeconds / 3600);
  const minutes = Math.floor((timeSeconds % 3600) / 60);
  const seconds = Math.floor(timeSeconds % 60);

  let minutesString = `${minutes}`;
  let secondsString = `${seconds}`;

  if (minutes < 10 && hours > 0) {
    minutesString = `0${minutes}`;
  }
  if (seconds < 10) {
    secondsString = `0${seconds}`;
  }

  if (hours === 0) {
    return `${minutesString}:${secondsString}`;
  }
  return `${hours}:${minutesString}:${secondsString}`;
}

export function convertTimeStringToSeconds(timeString: string) {
  const timeArray = timeString.split(":");
  let timeInSeconds = 0;

  if (timeArray.length === 2) {
    timeInSeconds =
      timeInSeconds + Number(timeArray[0]) * 60 + Number(timeArray[1]);
  } else if (timeArray.length === 3) {
    timeInSeconds =
      timeInSeconds +
      Number(timeArray[0]) * 3600 +
      Number(timeArray[1]) * 60 +
      Number(timeArray[2]);
  }

  return timeInSeconds;
}

export interface TimeRange {
  startsAtTimeSec: number;
  endsAtTimeSec: number;
}

export function hasOverlappingTimeRanges<T extends TimeRange>(
  ranges: T[]
): { index1: number; index2: number } | null {
  for (let i = 0; i < ranges.length; i++) {
    const range1Start = ranges[i].startsAtTimeSec;
    const range1End = ranges[i].endsAtTimeSec;

    for (let j = i + 1; j < ranges.length; j++) {
      const range2Start = ranges[j].startsAtTimeSec;
      const range2End = ranges[j].endsAtTimeSec;

      // Check if ranges overlap
      if (
        (range1Start <= range2Start && range2Start < range1End) || // range2 starts during range1
        (range2Start <= range1Start && range1Start < range2End) // range1 starts during range2
      ) {
        return { index1: i, index2: j };
      }
    }
  }
  return null;
}
